// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SiteUnidades_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** ResponseContract for POST /config/site_unidades/salvar and the archive/restore/delete actions. */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SiteUnidades_SalvarResponseDados {
id: number
acao: string
}

export type SiteUnidades_SalvarResponse = ApiResponse<SiteUnidades_SalvarResponseDados>;

registerResponseContract('SiteUnidades_SalvarResponse', {
  id:   { type: 'number',  required: true },
  acao: { type: 'string',  required: true },
})
